import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Text, Tooltip } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { isSelectedAmountValid } from '../../../ui/ChooseAmountInputWithSlider/isSelectedAmountValid';

export const FirstMonthlyRepayment = ({
    drawdownAmount,
    offer
}: {
    drawdownAmount: number;
    offer: TFormalOffer;
}) => {
    const { data } = useDrawdownRepaymentSchedule({
        offerId: offer.offer_id!,
        drawdownAmount,
        enabled: isSelectedAmountValid(drawdownAmount, offer),
        suspense: true
    });

    const firstMonthlyRate =
        data?.summary!.simplified_schedule!.next_repayment!.amount!;

    return (
        <div className="flex items-start justify-between">
            <div className="flex items-center gap-s">
                <Text>
                    <FormattedMessage
                        id="_.rcf_approved_view.offer_details_first_monthly_rate"
                        defaultMessage="First monthly rate"
                    />
                </Text>
                <Tooltip
                    data-testid="offer-details-first-monthly-rate-tooltip"
                    // @ts-expect-error
                    content={
                        <FormattedMessage
                            id="_.rcf_approved_view.offer_details_first_monthly_rate_tooltip"
                            defaultMessage="Consisting of the arrangement fee and the interest charged on the withdrawn amount."
                        />
                    }
                />
            </div>
            <div className="flex flex-col items-end">
                <Text className="text-l font-bold">
                    <FormattedCurrency value={firstMonthlyRate} />
                </Text>
                <Text className="text-s">
                    <FormattedMessage
                        id="_.rcf_approved_view.offer_details_estimated"
                        defaultMessage="(estimated)"
                    />
                </Text>
            </div>
        </div>
    );
};
